/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetDevices Input Action
 */
export class GetDevicesInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `GetDevicesKey`;
    public getCacheObjectType = () => 'GetDevices';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetDevicesData {
    text: string;
}

export interface ICipDeviceData {
    ActiveFromDate: string;
    Name: string;
    Id: string;
    AssetId: string;
    Model: string;
    ModelYear: string;
    StatusCode: string;
    StatusCodeFormatted: string;
    Location: string;
    ParentName: string;
    ProductName: string;
    ProductNumber: string;
    Acquisitiondate: string;
    NewGuaranteestartdate: string;
    Warranty: IWarranty;
    Properties: any[];
    ExtensionProperties: any[];
}

interface IWarranty {
    DurationMonths: Number;
    ExpirationDate: string;
    Id: string;
    Name: string;
    StartDate: string;
}

export interface ICipDevicesResponse {
    '@odata.context': string;
    value: ICipDeviceData[];
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetDevicesInput();
};

async function action(_: GetDevicesInput, ctx: Msdyn365.IActionContext): Promise<IGetDevicesData> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const response = await Msdyn365.sendRequest<IGetDevicesData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetDevices(language='${ctx.requestContext.locale}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${userToken}`
            }
        }
    );
    if (response.status === 200 && response.data) {
        return { ...response.data };
    }
    return { text: 'Static data from action' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetDevicesData>>action,
    id: 'GetDevices',
    input: createInput
});
